import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FileUpload } from 'primereact/fileupload';

import { Button, TextAreaField, DropDownField } from '../helpers';

import ApprovalHistory from './ApprovalHistory';

import { raiseToast } from '../services/redux/reducers/toast/toast';
import { getFullName } from '../utils';


const CommonApprovalDisplay = (props) => {
    const { 
        approvalBody,
        index,
        approval,
        isDoc,
        primaryApprover,
        handleApprovalRemarks,
        handleApproverChange,
        eachRequestDetail,
        approvalRequestStatusDetails,
        setApprovalRequestStatusDetails,
        historyRequests,
        approvedOrRejectedBy,
        isRequestRestricted
    } = props

    const dispatch = useDispatch()

    const userDetails = useSelector(state => state.userDetails)
    const companyRoles = userDetails.PMCompanyDetails.companyRoles

    useEffect(() => {
        if(!eachRequestDetail.notifyToUserId && primaryApprover.length === 1){
            handleApproverChange(eachRequestDetail.srNo, primaryApprover[0].userId)
        }
    }, [eachRequestDetail, primaryApprover])

    const displayApproverDetails = (allApprovers) => {
        let approverNames = []
        allApprovers.map(eachApprover => {
            approverNames.push(eachApprover.fullName)
        })
        return approverNames.join(", ")
    }

    const handleApprovalDocs = (approvalId, uploadFileData) => {
        let isFileAlreadyUploaded = false
        const updatedApprovalRequestStatusDetails = approvalRequestStatusDetails.map(eachRequestDetail => {
            if (eachRequestDetail.approvalId === approvalId) {
                if (!Array.isArray(eachRequestDetail.uploadFile)) {
                    eachRequestDetail.uploadFile = [uploadFileData]
                } else {
                    const isDuplicate = eachRequestDetail.uploadFile.some(existingFileObj =>
                        existingFileObj.dataURI === uploadFileData.dataURI
                    )
                    if (isDuplicate) {
                        isFileAlreadyUploaded = true
                    } else {
                        eachRequestDetail.uploadFile.push(uploadFileData)
                    }
                }
            }
            return eachRequestDetail
        })

        if (isFileAlreadyUploaded) {
            return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: 'This file is already uploaded.', life: 3000 }))
        }
        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const fileUploadHandler = ({ files, options }, doc_name, approvalId) => {
        const [file] = files;
        const fileReader = new FileReader();

        if (file.size > 5242880) {
            options.clear()
            return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: 'File size exceeds 5MB', life: 3000 }))
        }
        fileReader.onload = (e) => {
            const blob = URL.createObjectURL(file);
            file.objectURL = blob

            let uploadFileData = {
                url: file.objectURL,
                documentName: doc_name,
                fileName: file.name,
                dataURI: e.target.result,
                inputName: options.props.name,
            }
            
            if (approvalId) {
                handleApprovalDocs(approvalId, uploadFileData)
            }
        }
        fileReader.readAsDataURL(file)
        options.clear()
    }

    const removeApprovalDocProof = (index, approvalId, fileObj) => {
        const updatedApprovalRequestStatusDetails = approvalRequestStatusDetails.map(eachRequestDetail => {
            if (eachRequestDetail.approvalId === approvalId) {
                eachRequestDetail.uploadFile = eachRequestDetail.uploadFile.filter(eachUploadedFile => {
                    return eachUploadedFile.dataURI !== fileObj.dataURI
                })
            }
            return eachRequestDetail
        })
        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const fullNameTemplate = (option) => {
        if(!option) {
            return ""
        }
        return `${option.firstName} ${option.lastName}`;
    }

    const handleRaiseReq = (requestDetail) => {
        if(!eachRequestDetail.notifyToUserId){
            if(primaryApprover.length){
                return dispatch(raiseToast({ severity: 'error', detail: 'Select user to notify' }))
            }
        }
        props.handleRaiseReq(requestDetail)
    }
    
    const getPlaceHolderForApprovedBy = (approval) => {
        if(approval.approvalRole === "COMPANY ROLE"){
            const relatedCompanyRole = companyRoles.find(eachCompanyRole => eachCompanyRole.companyRoleId === approval.primaryApprover)
            if(relatedCompanyRole){
                return relatedCompanyRole.companyRoleName
            }
        }
        if(approval.approvalRole === "MANAGER"){
            return "MANAGER"
        }
        return "-"
    }

    return (
        <div key={`approval_display${index}`} className="p-card mb-2 py-2">
            <div className="flex justify-content-between w-full mb-0">
                <p className="text-sm font-semibold m-0">{eachRequestDetail.displayTitle ? eachRequestDetail.displayTitle : approval.approvalTitle}</p>
                <div className="flex">
                    {
                        isRequestRestricted ? 
                        null 
                        :
                        (
                            ["NOT REQUESTED", "REJECTED"].includes(eachRequestDetail.requestStatus) && primaryApprover.length ?
                            <>  
                                <span className="text-sm m-0 mr-1 mt-2">Notify to user: </span>
                                <DropDownField name="firstName" itemTemplate={fullNameTemplate} valueTemplate={fullNameTemplate} optionValue="userId" options={primaryApprover} value={eachRequestDetail.notifyToUserId} style={{width: "150px", marginRight: "15px", height: "30px"}} onChange={(e) => handleApproverChange(eachRequestDetail.srNo, e.value)} />
                            </>
                            :
                            null
                        )
                    }
                    {eachRequestDetail.requestStatus !== "NOT REQUESTED" ? <p className="text-sm font-semibold m-1">{eachRequestDetail.requestStatus}</p> : ""}
                    {
                        isRequestRestricted ?
                        null
                        :
                        (
                            <>
                                {
                                    isDoc && eachRequestDetail.requestStatus === "NOT REQUESTED" ? 
                                        <Button className="small-btn" label="Raise Request"  severity="warning" onClick={() => {handleRaiseReq(eachRequestDetail)}} permissions={[191]} applyThrottle={true}/> 
                                        : null
                                }
                                {
                                    isDoc && eachRequestDetail.requestStatus === "REJECTED" ? 
                                        <Button className="small-btn" label={"Raise Revised Request"}  severity="warning" onClick={() => {handleRaiseReq(eachRequestDetail)}} permissions={[191]} applyThrottle={true}/> : null
                                }
                            </>
                        )
                    }
                </div>
            </div>
            { ["NOT REQUESTED", "REQUESTED"].includes(eachRequestDetail.requestStatus) &&
                <p className="text-sm font-semibold m-0 text-color-secondary">Approval Manager: &nbsp;
                    <span className="text-sm font-normal m-0">
                        { isRequestRestricted ? 
                            "Pending From Buyer" 
                            : 
                            primaryApprover.length ? displayApproverDetails(primaryApprover) : getPlaceHolderForApprovedBy(approval)
                        }
                    </span>
                </p>
            }
            { ["APPROVED"].includes(eachRequestDetail.requestStatus) &&
                <p className="text-sm font-semibold m-0 text-color-secondary">Approved By: {getFullName(approvedOrRejectedBy?.firstName, approvedOrRejectedBy?.lastName)}</p>
            }
            { ["REJECTED"].includes(eachRequestDetail.requestStatus) &&
                <p className="text-sm font-semibold m-0 text-color-secondary">Rejected By: {getFullName(approvedOrRejectedBy?.firstName, approvedOrRejectedBy?.lastName)}</p>
            }

            {approvalBody}
            {
                !isRequestRestricted &&
                <div className="grid align-items-start">
                    {
                        ["NOT REQUESTED", "REJECTED"].includes(eachRequestDetail.requestStatus) && isDoc &&
                        <div className="col-12 lg:col-7 md:col-7">
                            <label className="font-medium">Remarks</label>
                            <TextAreaField
                                value={eachRequestDetail.remarks}
                                onChange={(e) => handleApprovalRemarks(eachRequestDetail.srNo, e.target.value, eachRequestDetail?.prefillText)}
                                maxLength={300}
                            />
                        </div>
                    }
                    {
                        approval.config?.isUploadFileAccessible &&
                        <>
                            {
                                ["NOT REQUESTED", "REJECTED"].includes(eachRequestDetail.requestStatus) && 
                                <div className="col-12 lg:col-2 md:col-2 px-3 mt-3">
                                    <FileUpload className="upload-btn" mode="basic" name="docProof" accept=".jpg,.jpeg,.png,.pdf,.html" customUpload auto chooseLabel="Upload File" uploadHandler={files => fileUploadHandler(files, "APPROVAL_DOCPROOF", eachRequestDetail.approvalId)} />
                                </div>
                            }
                            <div className="col-12 lg:col-3 md:col-3 mt-3">
                                <div className="grid">
                                    {
                                        Array.isArray(eachRequestDetail.uploadFile) && eachRequestDetail.uploadFile.length > 0 &&
                                        eachRequestDetail.uploadFile.map((eachFileObj, index) => {
                                            const fileUrl = eachFileObj.url || eachFileObj
                                            return (
                                                <div className="flex align-items-center col-4" key={index}>
                                                    <span>{index + 1}. </span>
                                                    <a
                                                        href={fileUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="mx-2"
                                                    >
                                                        View
                                                    </a>
                                                    <span
                                                        onClick={() => removeApprovalDocProof(index, eachRequestDetail.approvalId, eachFileObj)}
                                                        style={{ color: 'red', cursor: 'pointer', fontWeight: 'bold' }}
                                                    >
                                                        ×
                                                    </span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </>
                    }

                </div>
            }
            {   
                !["NOT REQUESTED"].includes(eachRequestDetail.requestStatus) &&
                    <div className="flex flex-column col-8 p-0">
                        {eachRequestDetail.requestStatus === "REQUESTED" && <p className="m-1">Requested Remarks: {eachRequestDetail.requestedRemarks ? eachRequestDetail.requestedRemarks : "NA"}</p>}
                        {eachRequestDetail.requestStatus === "APPROVED" && <p className="m-1">Approved Remarks: {eachRequestDetail.processedRemarks}</p>}
                        {eachRequestDetail.requestStatus === "REJECTED" && <p className="m-1">Rejected Remarks: {eachRequestDetail.processedRemarks}</p>}
                    </div>
            }

            { historyRequests.length > 0 && <ApprovalHistory approvalRequests={historyRequests} /> }
        </div>
    )
}

export default CommonApprovalDisplay;